import React from 'react';

const User = (props) => {
    return (
        <div className="user-box">
            <h1>
                <img
                    src={props.icon}
                    referrerPolicy="no-referrer"
                    style={{width: 25, height: 25, borderRadius: '50%'}}
                    alt=""
                />
                {/*for some reason here, you need to add the no-referrer in order to display some google account profile pictures. border radius of 50% makes it a circle*/}
                {props.user}
            </h1>
            <h2>{props.email}</h2>

            {props.email.includes("gmail") && <h3 style={{color:'green'}}>USES GMAIL</h3>}
            {props.email.includes("mvla.net") && <h3 style={{color:'green'}}>MVHS STUDENT</h3>}
        </div>
    );
};

export default User;